import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthGuardData, createAuthGuard } from 'keycloak-angular';

const isAccessAllowed = async (route: ActivatedRouteSnapshot, _: RouterStateSnapshot, authData: AuthGuardData): Promise<boolean | UrlTree> => {
  const { authenticated, grantedRoles } = authData;

  const hasInternalAccess = Object.values(grantedRoles.resourceRoles).some(userRoles => userRoles.includes('ATS__FRONT_ACCESS'));

  if (hasInternalAccess) {
    return true;
  } else return false;
};

export const canActivateInternalRole = createAuthGuard<CanActivateFn>(isAccessAllowed);
